import $ from "jquery";
import whatInput from "what-input";
import * as bootstrap from "bootstrap";
import AOS from "aos";

import { MyPN } from "./esm/pin.esm.js";
import { MyTG } from "./esm/toggle.esm.js";
import { MySD } from "./esm/send.esm.js";
import { MyHD } from "./esm/header.esm.js";
import { MyDR } from "./esm/drop.esm.js";
import { MyMQ } from "./esm/marquee.esm.js";
import { MyGM } from "./esm/maps.esm.js";
import { MyIF } from "./esm/viewer.esm.js";
import { MySW } from "./esm/swiper.esm.js";
import { MyYT } from "./esm/youtube.esm.js";
import { ForbesVideo } from "./esm/forbes-video.esm.js";
import { PardotIframe } from "./esm/pardot-iframe.esm.js";
import { FormEvents } from "./esm/formEvents.esm.js";
import { LanguageBanner } from "./esm/language-banner.esm.js";

import "@lottiefiles/lottie-player";

import { initLoading } from "./helpers/spinner.js";
import { initModernizr, isTouchDevice } from "./helpers/modernizr.js";
import { initClose } from "./helpers/closeFrame.js";
import {
  initBreakpointDetection,
  getCurrentBreakpoint,
} from "./helpers/breakpoints.js";
import "./helpers/resize.js";
import { initSplitText } from "./helpers/splitText.js";

initClose();
initModernizr();
initBreakpointDetection();
initSplitText();
initLoading();

document.addEventListener("DOMContentLoaded", (event) => {
  AOS.init();
  MyPN.initAll();
  MyTG.initAll();
  MySD.initAll();
  MyHD.initAll();
  MyDR.initAll();
  MyMQ.initAll();
  MyGM.initAll();
  MyIF.initAll();
  MySW.initAll();
  MyYT.initAll();
  ForbesVideo.initAll();
  PardotIframe.initAll();
  FormEvents.initAll();
  LanguageBanner.initAll();

  window.addEventListener("breakpointChange", (event) => {
    AOS.refresh();
    console.log("===> breakpointChange => ", event);
  });
  $(".collapse").on("shown.bs.collapse", (event) => {
    AOS.refresh();
    console.log("===> shown.bs.collapse => ", event);
  });
  $(".collapse").on("hidden.bs.collapse", (event) => {
    AOS.refresh();
    console.log("===> hidden.bs.collapse => ", event);
  });
  window.addEventListener("onResizeInit", (event) => {
    console.log("===> onResizeInit => ", event);
  });
  window.addEventListener("onResizeEnd", (event) => {
    AOS.refresh();
    console.log("===> onResizeEnd => ", event);
  });
});

